document.addEventListener('DOMContentLoaded', () => {
	const openMobileNav = document.querySelector('.mobile-toggle-button');
	const closeMobileNav = document.querySelector('.mobile-close-button');
	const pageElement = document.getElementById('page');
	const html = document.querySelector('html');
	let scrollOffset = 0;
	const documentCloseEventListener = (e) => {
		if (!e.target.closest('#mobile-header') || e.target.closest('.newsletter-button')) {
			closeNav(e);
		}
	};

	const preventScroll = () => {
		pageElement.style.setProperty('--scroll-offset', `-${scrollOffset}px`);
	};

	const returnScroll = () => {
		const offset = parseInt(scrollOffset);
		window.scrollTo(0, offset);
		setTimeout(() => {
			pageElement.style.setProperty('--scroll-offset', '');
		});
	};

	const openNav = (e) => {
		e.preventDefault();
		scrollOffset = window.scrollY;

		html.classList.add('mobile-overlay-shown');
		html.classList.add('mobile-nav-expanded');
		preventScroll();
		setTimeout(() => {
			document.addEventListener('click', documentCloseEventListener);
		}, 10);
	};

	let closeNav = (e) => {
		e.preventDefault();
		html.classList.remove('mobile-nav-expanded');
		setTimeout(() => {
			html.classList.remove('mobile-overlay-shown');
		}, 350);
		document.removeEventListener('click', documentCloseEventListener);
		returnScroll();
	};

	openMobileNav.addEventListener('click', openNav);
	closeMobileNav.addEventListener('click', closeNav);

	handleSubmenuToggle();
	addWrapperToMobileSubMenu();
});

// Manage the submenu toggle
function handleSubmenuToggle() {
	const firstLevelMenus = document.querySelectorAll('.menu-item-has-children');
	if (!firstLevelMenus.length) return;

	let timeoutId;

	firstLevelMenus.forEach((subMenu) => {
		const submenuList = subMenu.querySelector('.sub-menu');
		const isDesktopMenu = subMenu.closest('#site-header');

		// Click handler
		subMenu.addEventListener('click', (e) => {
			submenuList.classList.toggle('sub-menu-expanded');
		});

		if (isDesktopMenu) {
			// Mouse enter handler - desktop only
			subMenu.addEventListener('mouseenter', () => {
				clearTimeout(timeoutId);
				submenuList.classList.add('sub-menu-expanded');
			});

			// Mouse leave handler - desktop only
			subMenu.addEventListener('mouseleave', () => {
				timeoutId = setTimeout(() => {
					submenuList.classList.remove('sub-menu-expanded');
				}, 200);
			});
		}
	});
}

function addWrapperToMobileSubMenu() {
	const mobileMenu = document.querySelector('#mobile-menu');
	if (!mobileMenu) return;
	const mobileMenuItems = mobileMenu.querySelectorAll('.menu-item-has-children');
	if (!mobileMenuItems.length) return;

	mobileMenuItems.forEach((menuItem) => {
		const submenuList = menuItem.querySelector('.sub-menu');
		const submenuWrapper = document.createElement('div');
		submenuWrapper.classList.add('sub-menu-wrapper');
		submenuWrapper.appendChild(submenuList);
		menuItem.appendChild(submenuWrapper);
	});
}
